export default "__VITE_ASSET__6a60912f__"